import NotificationServices from "@/admin/services/NotificationServices";
import OrderServices from "@/admin/services/OrderServices";

export default (args) => {
  new NotificationServices(args);
  new OrderServices(args);
}
